// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7911":"81571c8a45831411","9295":"64922dbf597f5a4e"}[chunkId] + ".js";
};